import listSaga from './listSaga'
import editSaga from './editSaga'
import oneContactSaga from './oneContactSaga'
import assignedListSaga from './assignedListSaga'
import advancedListSaga from './advancedListSaga'
import getPreSignedUploadURLSaga from './getPreSignedUploadURLSaga'
import uploadImageSaga from './uploadImageSaga'
import deleteContactSaga from './deleteSaga'
import moveToCompanySaga from './moveToCompany'

const companiesSagas = [
    listSaga(),
    oneContactSaga(),
    editSaga(),
    assignedListSaga(),
    advancedListSaga(),
    getPreSignedUploadURLSaga(),
    uploadImageSaga(),
    deleteContactSaga(),
    moveToCompanySaga()
]

export default companiesSagas
